import axiosInstance from "./BaseService";
import GroupData from "../models/GroupData";

// Function to fetch all groups with search and pagination
const fetchGroups = async (page: number = 1, limit: number = 12, search: string = '', country: string = 'IN', state: string = '') => {
    try {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
            country,
            ...(search && { search }),
            ...(state && { state })
        });
        const response = await axiosInstance.get(`/groups?${params}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}
// Function to fetch a group by ID
const fetchGroupById = async (groupId: string) => {
    try {
        const response = await axiosInstance.get<GroupData>(`/groups/${groupId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function to fetch a group by groupCode
const fetchGroupByCode = async (groupCode: string) => {
    try {
        const response = await axiosInstance.get<GroupData>(`/groups/code/${groupCode}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}
// Function to create a new group
const createGroup = async (groupData: GroupData) => {
    try {
        const response = await axiosInstance.post<GroupData>("/groups", groupData);
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function to update an existing group
const updateGroup = async (groupId: string, groupData: GroupData) => {
    try {
        const response = await axiosInstance.put<GroupData>(`/groups/${groupId}`, groupData);
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function to delete a group
const deleteGroup = async (groupId: string) => {
    try {
        const response = await axiosInstance.delete(`/groups/${groupId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function to fetch groups by pagination and orderby
const fetchGroupsByPagination = async (page: number, limit: number, orderBy: string) => {
    try {
        const response = await axiosInstance.get<any>(`/groups/pagination`, {
            params: {
                page,
                limit,
                orderBy
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function to fetch groups by search query
const fetchGroupsBySearch = async (searchQuery: string) => {
    try {
        const response = await axiosInstance.get<GroupData[]>(`/groups/search/${searchQuery}`);
        if (!Array.isArray(response.data)) {
            throw new Error("Invalid response format");
        }
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function to fetch groups bby state
const fetchGroupsByState = async (state: string) => {
    try {
        const response = await axiosInstance.get<GroupData[]>(`/groups/state/` + state);
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function to fetch groups ordered by featured status
const fetchFeaturedGroups = async (page: number, limit: number) => {
    try {
        const response = await axiosInstance.get<any>(`/groups/featured`, {
            params: {
                page,
                limit
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function to fetch groups by program ID
const fetchGroupsByProgram = async (programId: string) => {
    try {
        const response = await axiosInstance.get<GroupData[]>(`/groups/program/${programId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export {
    fetchGroups,
    fetchGroupById,
    fetchGroupByCode,
    createGroup,
    updateGroup,
    deleteGroup,
    fetchGroupsByPagination,
    fetchGroupsBySearch,
    fetchGroupsByState,
    fetchFeaturedGroups,
    fetchGroupsByProgram
};